import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton } from "@mui/material";
import {
  ActionSheetMenu,
  ActionSheetMenuItem,
  ResponsiveActionSheetMenu,
} from "@shared/components/ActionSheetMenu";

type ContactsListActionsMenuProps = {
  onViewBriefingClick: () => void;
  onDeleteClick: () => void;
  isDeleteDisabled?: boolean;
};

export const ContactsListActionsMenu = (
  props: ContactsListActionsMenuProps,
) => {
  const {
    onViewBriefingClick,
    onDeleteClick,
    isDeleteDisabled = false,
  } = props;

  return (
    // MUI portals the menu to document.body, but clicks still bubble through the React tree to here.
    <div onClick={(event) => event.stopPropagation()}>
      <ResponsiveActionSheetMenu
        renderTrigger={({ triggerRef, onClick, isSheet }) => (
          <IconButton
            ref={triggerRef}
            onClick={onClick}
            size="small"
            aria-label="Contact options"
            sx={
              isSheet
                ? { "&:focus": { backgroundColor: "transparent" } }
                : undefined
            }
          >
            <MoreHorizIcon fontSize="small" />
          </IconButton>
        )}
      >
        {(closeMenu) => (
          <ActionSheetMenu>
            <ActionSheetMenuItem
              icon={<VisibilityOutlinedIcon />}
              label="View briefing"
              onClick={() => {
                closeMenu();
                onViewBriefingClick();
              }}
            />
            <ActionSheetMenuItem
              icon={<DeleteOutlineIcon />}
              label="Delete"
              disabled={isDeleteDisabled}
              onClick={() => {
                closeMenu();
                onDeleteClick();
              }}
            />
          </ActionSheetMenu>
        )}
      </ResponsiveActionSheetMenu>
    </div>
  );
};
